<template>
  <div
    :class="[
      'main-menu',
      {
        'primary-menu-open': primaryMenuOpen,
        'secondary-menu-open': secondaryMenuOpen
      }
    ]"
  >
    <primary-menu
      :menu="menu"
      :current-url="currentUrl"
      :primary-menu-active-item="primaryMenuActiveItem"
      :primary-menu-open="primaryMenuOpen"
      :two-level-menus="twoLevelMenus"
      @menuSelected="selectPrimaryMenuItem"
      @itemSelected="item => openLink(item.link)"
    />
    <secondary-menu
      :menu="secondaryMenu"
      :current-url="currentUrl"
      :close-label="closeLabel"
      @itemSelected="item => openLink(item.link)"
      @closed="closeSecondaryMenu"
    />
    <button
      class="btn-primary primary-menu-toggle"
      @click.prevent="togglePrimaryMenu"
    >
      <span class="sr-only">{{ toggleLabel }}</span>
      <span class="af-icons af-icons-chevron-up"></span>
    </button>
  </div>
</template>

<script>
import $ from 'jQuery';
import Storage from '@/lib/storage.js';
import PrimaryMenu from './PrimaryMenu';
import SecondaryMenu from './SecondaryMenu';

const Cookies = {
  PRIMARY_MENU_PREFERENCE: 'primary-menu-preference',
  SECONDARY_MENU_PREFERENCE: 'secondary-menu-preference'
};

const MENU_OPEN = 'open';
const MENU_CLOSED = 'closed';

export default {
  components: {
    PrimaryMenu,
    SecondaryMenu
  },
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    toggleLabel: {
      type: String,
      default: 'Toggle navigation'
    },
    closeLabel: {
      type: String,
      default: 'Close'
    }
  },
  data() {
    return {
      currentUrl: null,

      primaryMenuOpen: true,
      primaryMenuActiveItem: null,
      primaryMenuPreference: MENU_OPEN,

      secondaryMenuOpen: false,
      secondaryMenuPreference: MENU_CLOSED
    };
  },
  computed: {
    twoLevelMenus() {
      return this.menu
        .filter(
          item =>
            item.children &&
            item.children.filter(
              child => child.children && child.children.length
            ).length > 0
        )
        .map(item => item.name);
    },
    secondaryMenu() {
      if (this.twoLevelMenus.includes(this.primaryMenuActiveItem)) {
        return this.menu.find(item => item.name === this.primaryMenuActiveItem);
      }
      return {};
    }
  },
  watch: {
    primaryMenuOpen() {
      setTimeout(this.slideinEvent, 300);
    },
    secondaryMenuOpen() {
      setTimeout(this.slideinEvent, 300);
    }
  },
  created() {
    this.storage = new Storage();

    this.loadPreferences();
    this.refreshCurrentUrl();

    $('body').on('pjax:popstate', this.refreshCurrentUrl);
    $('body').on('pjax:end', this.refreshCurrentUrl);
  },
  beforeDestroy() {
    $('body').off('pjax:popstate', this.refreshCurrentUrl);
    $('body').off('pjax:end', this.refreshCurrentUrl);
  },
  methods: {
    hasSecondaryMenu(item) {
      return this.twoLevelMenus.includes(item.name);
    },
    hasSubMenu(item) {
      return item.children !== undefined && item.children.length > 0;
    },
    selectPrimaryMenuItem(item) {
      this.primaryMenuActiveItem = item.name;

      if (this.hasSubMenu(item) && !this.hasSecondaryMenu(item)) {
        this.primaryMenuOpen = true;
      } else if (
        this.hasSecondaryMenu(item) &&
        this.primaryMenuPreference === MENU_CLOSED
      ) {
        this.primaryMenuOpen = false;
      } else {
        this.primaryMenuOpen = this.primaryMenuPreference === MENU_OPEN;
      }

      this.secondaryMenuOpen = this.hasSecondaryMenu(item);

      if (this.secondaryMenuOpen) {
        this.savePreferences();
      }

      if (item.link) {
        this.openLink(item.link);
      }
    },
    openLink(link) {
      this.currentUrl = link;
      $.pjax({ url: link, container: '#pjaxContainer', method: 'GET' });
    },
    togglePrimaryMenu() {
      this.primaryMenuOpen = !this.primaryMenuOpen;

      this.savePreferences();
    },
    closeSecondaryMenu() {
      this.secondaryMenuOpen = false;

      this.savePreferences();
    },
    recursiveSearch(menu) {
      if (menu.link && this.currentUrl.lastIndexOf(menu.link, 0) === 0) {
        return menu;
      } else {
        if (menu.children) {
          return menu.children.find(this.recursiveSearch);
        }
      }
      return null;
    },
    findMenu() {
      // Give priority to the part of the tree that holds the active primary menu item
      let menu = this.menu
        .filter(m => m.name === this.primaryMenuActiveItem)
        .find(this.recursiveSearch);

      // If not found, search the entire tree
      return menu || this.menu.find(this.recursiveSearch);
    },
    refreshCurrentUrl() {
      this.currentUrl = window.location.href;
      this.primaryMenuOpen = this.primaryMenuPreference === MENU_OPEN;

      // Recursive search based on the current URL
      const menu = this.findMenu();

      if (menu) {
        this.primaryMenuActiveItem = menu.name;
        this.secondaryMenuOpen =
          this.hasSecondaryMenu(menu) &&
          this.secondaryMenuPreference === MENU_OPEN;
      }
    },
    loadPreferences() {
      this.primaryMenuPreference =
        this.storage.get(Cookies.PRIMARY_MENU_PREFERENCE) || MENU_OPEN;
      this.secondaryMenuPreference =
        this.storage.get(Cookies.SECONDARY_MENU_PREFERENCE) || MENU_CLOSED;
    },
    savePreferences() {
      this.primaryMenuPreference = this.primaryMenuOpen
        ? MENU_OPEN
        : MENU_CLOSED;
      this.secondaryMenuPreference = this.secondaryMenuOpen
        ? MENU_OPEN
        : MENU_CLOSED;

      this.storage.set(
        Cookies.PRIMARY_MENU_PREFERENCE,
        this.primaryMenuPreference
      );
      this.storage.set(
        Cookies.SECONDARY_MENU_PREFERENCE,
        this.secondaryMenuPreference
      );
    },
    slideinEvent() {
      $(window).trigger('slidein');
    }
  }
};
</script>
